import { EVENT_FIELD_MAPPING } from '../common/store/constants/sportTypes';
import { foldTurkishI } from './stringHelpers';

export const normalizeMarketGroups = marketGroups =>
  marketGroups?.map(marketGroup => ({
    odds: marketGroup.odds?.map(odd => ({ n: odd.n }))
  }));

export const mapEventForSorting = event => ({
  id: event.id,
  competitionId: event.competitionId,
  otherOdd: null,
  marketGroups: normalizeMarketGroups(event.marketGroups),
  hasParentEvent: event.hasParentEvent,

  slgn: event.slgn,
  esd: event.esd,
  esdl: event.esdl,
  lgn: event.lgn,
  mbs: event.mbs,

  brdId: event.brdId,
  bs: event.bs,
  il: event.il,
  him: event.him,
  bf: event.bf,

  strd: event.strd,
  strt: event.strt,
  et: event.et,
  st: event.st,
  ev: event.ev,

  htpi: event.htpi,
  atpi: event.atpi,
  htn: event.htn,
  atn: event.atn,
  htjl: event.htjl,
  atjl: event.atjl,

  en: event.en,
  n: event.n,
  lgo: event.lgo,

  cl: event.cl,
  htw: event.htw,
  cb: event.cb,

  aRCrdCnt: event.aRCrdCnt,
  hRCrdCnt: event.hRCrdCnt,
  hls: event.hls,
  chnl: event.chnl,
  hwc: event.hwc,

  ibo: event.ibo,
  lted: event.lted,
  aut: event.aut,

  podds: event.podds,
  apodds: event.apodds,

  cid: event.cid ?? event.competitionId,

  market: event.market,
  count: event.count,

  homeTeam: event.homeTeam,
  hasBilyonerLiveStream: event.hasBilyonerLiveStream,

  finalTimeHandicapAway: event.finalTimeHandicapAway,
  finalTimeHandicapHome: event.finalTimeHandicapHome,

  parentEvent: event.parentEvent
});

export const mapEventsForSorting = ({ events = [], realEvents = {} }) =>
  events
    .map(groupEvent => realEvents?.[String(groupEvent.id)] || groupEvent)
    .filter(Boolean)
    .map(mapEventForSorting);

export const mapGroupsForSorting = ({ groups = [], realEvents = {} }) =>
  groups.map(group => ({
    startDate: group[EVENT_FIELD_MAPPING.startDate],
    startTime: group[EVENT_FIELD_MAPPING.startTime],
    eventStartDateAsLong: group[EVENT_FIELD_MAPPING.eventStartDateLong],
    name: group[EVENT_FIELD_MAPPING.leagueName],
    tabType: group[EVENT_FIELD_MAPPING.sportType],
    events: mapEventsForSorting({
      events: group.events || [],
      realEvents
    }),
    isUpcoming: false,
    firstCompetitionId: group[EVENT_FIELD_MAPPING.competitionId],
    lgo: group[EVENT_FIELD_MAPPING.leagueOrderNo]
  }));

export const createGroupObject = (group, events) => {
  const item = group?.events?.[0];
  if (!item) return null;

  const lgn = group?.name ?? item[EVENT_FIELD_MAPPING.leagueName];
  const lgo = group?.lgo ?? item[EVENT_FIELD_MAPPING.leagueOrderNo];
  const strd = group?.startDate ?? item[EVENT_FIELD_MAPPING.startDate];
  const strt = group?.startTime ?? item[EVENT_FIELD_MAPPING.startTime];
  const tabType = group?.tabType ?? item[EVENT_FIELD_MAPPING.sportType];
  const esdl = group?.eventStartDateAsLong ?? item[EVENT_FIELD_MAPPING.eventStartDateLong];
  const cid = group?.firstCompetitionId ?? item.competitionId;

  const groupUniqKey = esdl + '_' + lgn;

  return {
    key: groupUniqKey,
    value: {
      lgn,
      lgo,
      strd,
      strt,
      tabType,
      st: tabType,
      esdl,
      cid,
      id: item.id,
      events,
      htpi: item[EVENT_FIELD_MAPPING.homeTeamId],
      atpi: item[EVENT_FIELD_MAPPING.awayTeamId],
      cb: item[EVENT_FIELD_MAPPING.competitionBanner]
    }
  };
};

export const mapGroupToSportsBookGroup = group => {
  if (!group?.events?.length) return null;

  const result = createGroupObject(
    group,
    group.events.map(generateNewItemObj)
  );

  return result?.value ?? null;
};

export const mapGroupsToSportsBookArray = (groups = []) =>
  groups
    .map(mapGroupToSportsBookGroup)
    .filter(Boolean);

export const generateNewItemObj = item => (
  {
    id: item.id,
    search: generateSearchText(item),
    mbs: item[EVENT_FIELD_MAPPING.minSelectionCount],
    hasLiveStream: item[EVENT_FIELD_MAPPING.hasLiveStream],
    liveEvent: item[EVENT_FIELD_MAPPING.isLiveEvent],
    hasWriterComment: item[EVENT_FIELD_MAPPING.hasWriterComment],
    hasRapidMarket: item[EVENT_FIELD_MAPPING.hasRapidMarket],
    hasTopWin: item[EVENT_FIELD_MAPPING.hasTopWin],
    aut: item[EVENT_FIELD_MAPPING.writers],
    strd: item[EVENT_FIELD_MAPPING.startDate],
    strt: item[EVENT_FIELD_MAPPING.startTime],
  });

export const generateSearchText = event => {
  let searchText = ((event?.[EVENT_FIELD_MAPPING.eventName] || '') + '//'
    + (event?.[EVENT_FIELD_MAPPING.shortLeagueName] || '') + '//'
    + (event?.[EVENT_FIELD_MAPPING.leagueName] || '') + '//'
    + (event?.[EVENT_FIELD_MAPPING.homeTeamName] || '') + '//'
    + (event?.[EVENT_FIELD_MAPPING.awayTeamName] || '') + '//'
    + event?.id);

  if (event?.[EVENT_FIELD_MAPPING.sportType] > 1000) { // uzun vadeli
    const teamNames = event.marketGroups?.[0]?.odds.reduce((acc, cur) => {
      acc += cur?.[EVENT_FIELD_MAPPING.name] + '//';
      return acc;
    }, '');
    return foldTurkishI(searchText + '//' + teamNames).toLowerCase();
  }
  return foldTurkishI(searchText).toLowerCase();
};
